import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'applyProvidedPipe',
  standalone: true
})
export class ApplyProvidedPipePipe implements PipeTransform {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  transform(value: any, displayPipe?: PipeTransform): any {
    if (value !== undefined && displayPipe && displayPipe.transform) {
      return displayPipe.transform(value);
    } else {
      return value;
    }
  }
}
